<template>
  <div style="width: 100%; height: 100%; position: relative" class="tdt">
    <!-- 搜索框 -->
    <div style="margin-bottom: 8px">
      <a-input-search
        v-model="keyword"
        placeholder="请输入地址搜索"
        @search="searchAddress"
        enter-button
      />
    </div>
    <div class="tdt-map" ref="map" style="width: 100%; height: 500px"></div>
  </div>
</template>

<script>
import loadTDT from "@/utils/loadTDT.js";

export default {
  name: "TdtPickMap",
  props: {
    tk: { type: String, required: true },
    center: { type: Array, default: () => [116.40769, 39.89945] },
    zoom: { type: Number, default: 12 },
    pickIcon: {
      type: String,
      default: null, // 比如 require("@/assets/locationMap3.png")
    },
  },

  data() {
    return {
      map: null,
      pickMarker: null,
      T: null,
      keyword: "",
    };
  },

  async mounted() {
    const T = await loadTDT(this.tk);
    this.T = T;

    this.$nextTick(() => {
      this.initMap(T);
    });
  },

  methods: {
    initMap(T) {
      this.map = new T.Map(this.$refs.map, { projection: "EPSG:3857" });

      const center = new T.LngLat(this.center[0], this.center[1]);
      this.map.centerAndZoom(center, this.zoom);
      this.map.enableScrollWheelZoom();

      this.map.addControl(new T.Control.Scale());
      this.map.addControl(new T.Control.Zoom());

      this.map.addEventListener("click", (e) => {
        const { lng, lat } = e.lnglat;
        this.pickPoint(T, lng, lat);
      });
    },

    async pickPoint(T, lng, lat) {
      // 移除旧标点
      if (this.pickMarker) {
        this.map.removeOverLay(this.pickMarker);
      }

      // 创建图标（如果有）
      let markerOpts = {};
      if (this.pickIcon) {
        const icon = new T.Icon({
          iconUrl: this.pickIcon,
          iconSize: new T.Point(40, 40),
          iconAnchor: new T.Point(20, 40),
        });
        markerOpts.icon = icon;
      }

      // 创建标点
      const point = new T.LngLat(lng, lat);
      this.pickMarker = new T.Marker(point, markerOpts);
      this.map.addOverLay(this.pickMarker);

      // 逆地理地址解析
      //换成后端接口
      const url = `http://api.tianditu.gov.cn/geocoder?postStr={"lon":${lng},"lat":${lat},"ver":1}&type=geocode&tk=${this.tk}`;
      const res = await fetch(url);
      const data = await res.json();

      const comp = data?.result?.addressComponent || {};
      //换成后端接口
      // 回传结果
      this.$emit("picked", {
        lng,
        lat,
        address: data?.result?.formatted_address || "",
        province: comp.province || "",
        city: comp.city || "",
        district: comp.district || "",
        town: comp.town || "",
        street: comp.road || "",
        raw: data?.result || {},
      });
    },

    // 搜索地址 -> 自动定位并标点
    async searchAddress() {
      if (!this.keyword) return;
      //换成后端接口
      const url = `http://api.tianditu.gov.cn/geocoder?ds={"keyWord":"${this.keyword}"}&tk=${this.tk}`;
      const res = await fetch(url);
      const result = await res.json();
      //换成后端接口
      if (!result?.location) {
        this.$message.error("未找到该地址");
        return;
      }

      const { lon, lat } = result.location;
      const point = new this.T.LngLat(lon, lat);

      this.map.panTo(point);
      this.pickPoint(this.T, lon, lat);
    },

    // 拾取标点 + 逆地理
    async pickPoint(T, lng, lat) {
      if (this.pickMarker) this.map.removeOverLay(this.pickMarker);

      let markerOpts = {};
      if (this.pickIcon) {
        const icon = new T.Icon({
          iconUrl: this.pickIcon,
          iconSize: new T.Point(40, 40),
          iconAnchor: new T.Point(20, 40),
        });
        markerOpts.icon = icon;
      }

      const point = new T.LngLat(lng, lat);
      this.pickMarker = new T.Marker(point, markerOpts);
      this.map.addOverLay(this.pickMarker);

      const url = `http://api.tianditu.gov.cn/geocoder?postStr={"lon":${lng},"lat":${lat},"ver":1}&type=geocode&tk=${this.tk}`;
      const res = await fetch(url);
      const data = await res.json();
      const comp = data?.result?.addressComponent || {};

      this.$emit("picked", {
        lng,
        lat,
        address: data?.result?.formatted_address || "",
        province: comp.province || "",
        city: comp.city || "",
        district: comp.district || "",
        town: comp.town || "",
        street: comp.road || "",
      });
    },
  },
};
</script>

<style scoped>
.tdt /deep/ input.ant-input {
  height: 32px !important;
  border-radius: 4px;
}
</style>
